import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, ProfileCompletionAction } from 'ui'
import { User } from '../queries'

interface ProfileCompletionCardProps {
  profile: User | null
  className?: string
}

export const ProfileCompletionCard: React.FC<ProfileCompletionCardProps> = ({
  profile,
  className = '',
}) => {
  const navigate = useNavigate()

  const getProfileCompletionActions = useMemo((): ProfileCompletionAction[] => {
    if (!profile) return []

    const userRole = profile.userRole?.toLowerCase() || ''
    const isEducator = userRole === 'educator'
    const isProfessional = userRole === 'professional'

    return [
      ...(isProfessional
        ? [
            {
              label: 'Job Field',
              completed: !!profile.jobField,
              path: `/app/settings/edit?targetField=jobField&tab=about`,
            },
          ]
        : []),
      ...(isEducator
        ? [
            {
              label: 'Types of Classes',
              completed: !!profile.contentDescription,
              path: `/app/settings/edit?targetField=contentDescription&tab=interests`,
            },
          ]
        : []),
      isProfessional
        ? {
            label: 'Areas of Expertise',
            path:
              '/app/settings/edit?targetField=contentDescription&tab=interests',
            completed: !!profile.contentDescription,
          }
        : {
            label: 'Types of Professionals',
            path: `/app/settings/edit?targetField=collaboratorDescription&tab=interests`,
            completed: !!profile.collaboratorDescription,
          },
      ...(isProfessional
        ? [
            {
              label: 'Connection Preferences',
              path: `/app/settings/edit?targetField=connectionPreference&tab=interests`,
              completed:
                !!profile.connectionPreference &&
                profile.connectionPreference.length > 0,
            },
          ]
        : []),
      {
        label: 'Keywords',
        path: `/app/settings/edit?targetField=keywords&tab=interests`,
        completed: !!profile.keywords && profile.keywords.length > 0,
      },
      {
        label: 'Public Bio',
        path: `/app/settings/edit?targetField=publicBio&tab=bio`,
        completed: !!profile.publicBio,
      },
      {
        label: 'About Me',
        path: `/app/settings/edit?targetField=about&tab=about`,
        completed: !!profile.about,
      },
    ]
  }, [profile])

  const handleActionClick = (path: string) => {
    navigate(path)
  }

  const completedActions = getProfileCompletionActions.filter(
    (action) => action.completed
  )
  const percentComplete = Math.round(
    (completedActions.length / getProfileCompletionActions.length) * 100
  )

  return (
    <Card.ProfileCompletion
      actions={getProfileCompletionActions}
      percentComplete={percentComplete}
      onActionClick={handleActionClick}
      className={className}
    />
  )
}
